import { useNuxtApp } from "#app"; // 导入 `useNuxtApp`
import { getPrefixUrl } from "@/utils/globalData"; // 导入 `useNuxtApp`
import { useMainStore } from "../composables/store";
import { makeUnSetupFetch } from "./index";
/**
 * 获取当前用户信息
 * @param params
 * @returns {*}
 */
export function getCurrentUserData(body, $fetch, headers) {
  return useNuxtApp().$customFetch("/mall/portal/user/query?isShop=1", {
    method: "POST",
    body: {
      ...body,
      param: {
        account: window.localStorage.getItem("lastLoginAccount"),
      },
    },
  });
}

/**
 * 获取当前商城用户信息
 * @param params
 * @returns {*}
 */
export function getCurrentMallUserData(body, $fetch, headers) {
  return useNuxtApp().$customFetch(
    "/mallSite/portal/auth/loginTourists?mall=1",
    { method: "POST", body }
  );
}
/**
 * 翻译数据
 * @param params
 * @returns {*}
 */
export function alibabaProductTextTranslate(body, $fetch, headers) {
  return useNuxtApp().$customFetch(
    "mallSite/admin/alibabaGoods/alibabaProductTextTranslate?mall=1&uncheck401=1",
    { method: "POST", body }
  );
}

/**
 * 获取当前汇率 币种
 * @param params
 * @returns {*}
 */
export function getCurrencyDataList(body, $fetch, headers) {
  return new Promise((resolve) => {
    resolve({
      data: {
        dataList: [],
      },
    });
  });
  // return useNuxtApp().$customFetch(
  //   "../collectionSite/portal/dealerShopCurrencyRate/queryPageList?collection=1",
  //   { method: "POST", body }
  // );
}

 
/**
 * 邮箱登录
 * @param params
 * @returns {*}
 */
export function emailLogin(body) {
  return useNuxtApp().$customFetch("/mall/portal/auth/loginWithEmailVerificationCode?isShop=1", {
    method: "POST",
    body:{
      ...(body || {}),
      shopId: (process.client ?useCookie('dealerShopId').value : "")
    }
  });
}

 
/**
 * 邮箱登录
 * @param params
 * @returns {*}
 */
export function getEmailLoginCode(body) {
  return useNuxtApp().$customFetch("/mall/portal/auth/sendEmailVerificationCode?isShop=1", {
    method: "POST",
    body:{
      ...(body||{}),
      shopId: (process.client ?useCookie('dealerShopId').value : "")
    }
  });
}

/**
 * 登录
 * @param params
 * @returns {*}
 */
export function login(body) {
  return useNuxtApp().$customFetch("/mall/portal/auth/login?isShop=1", {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    method: "POST",
    body: (() => {
      const form = new URLSearchParams();
      if (body && typeof body === "object") {
        Object.entries(body).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            form.append(key, String(value));
          }
        });
      }
      return form;
    })(),
  });
}

/**
 * 验证码
 * @param params
 * @returns {*}
 */
export function validateSmsCode(body) {
  return useNuxtApp().$customFetch(
    "/mall/portal/auth/validateSmsCode?isShop=1",
    {
      method: "POST",
      body,
    }
  );
}

/**
 * 注册请求
 * @param params
 * @returns {*}
 */
export function regist(body) {
  return useNuxtApp().$customFetch("/mall/portal/auth/regist?isShop=1", {
    method: "POST",
    body,
  });
}

/**
 * 图片验证码
 * @param params
 * @returns {*}
 */
export function getImgCode(body) {
  return useNuxtApp().$customFetch("/mall/portal/auth/getImgCode?isShop=1", {
    method: "POST",
    body,
  });
}

/**
 * 验证图片验证码
 * @param params
 * @returns {*}
 */
export function validateImgCode(body) {
  return useNuxtApp().$customFetch(
    "/mall/portal/auth/validateImgCode?isShop=1",
    {
      method: "POST",
      body,
    }
  );
}

/**
 * 发送短信验证码
 * @param params
 * @returns {*}
 */
export function sendSmsCode(body) {
  return useNuxtApp().$customFetch("/mall/portal/auth/sendSmsCode?isShop=1", {
    method: "POST",
    body,
  });
}

/**
 * 通过邮件找回密码
 * @param params
 * @returns {*}
 */
export function resetAndEmail(body) {
  return useNuxtApp().$customFetch(
    "/mall/portal/user/pwd/resetAndEmail?isShop=1",
    {
      method: "POST",
      body,
    }
  );
}

/**
 * 添加商品到购物车
 * @param {Object} param - 参数对象
 * @param {number} param.buyAmount - 购买数量
 * @param {string} param.specsInfo - 规格信息
 * @param {string} param.dealerItemSkuId - SKU ID
 * @param {string} param.dealerShopLiveStreamerId - 直播主播ID（可选）
 * @returns {Promise}
 */
export function addToCart(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallShoppingCart/add?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          buyAmount: param.buyAmount || 1,
          specsInfo: param.specsInfo || "",
          dealerItemSkuId: param.dealerItemSkuId,
          dealerShopLiveStreamerId: param.dealerShopLiveStreamerId || "",
        },
      },
    }
  );
}

/**
 * 获取购物车列表
 * @param {Object} param - 参数对象
 * @param {number} param.pageNo - 页码，从0开始
 * @param {number} param.pageSize - 每页大小
 * @returns {Promise}
 */
export function getCartList(param = {}) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallShoppingCart/list?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          pageNo: param.pageNo || 0,
          pageSize: param.pageSize || 100000,
        },
      },
    }
  );
}

/**
 * 删除购物车商品
 * @param {Object} param - 参数对象
 * @param {string} param.id - 购物车商品ID
 * @returns {Promise}
 */
export function removeFromCart(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallShoppingCart/delete?isShop=1",
    {
      method: "POST",
      body: {
        param: [{  dealerItemSkuId: param.id}]
      }
    }
  );
}

/**
 * 更新购物车商品数量
 * @param {Object} param - 参数对象
 * @param {string} param.id - 购物车商品ID
 * @param {number} param.buyAmount - 购买数量
 * @returns {Promise}
 */
export function updateCartQuantity(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallShoppingCart/update?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          id: param.id,
          buyAmount: param.buyAmount,
        },
      },
    }
  );
}

/**
 * 修改购物车商品数量
 * @param {Object} param - 参数对象
 * @param {string} param.dealerItemSkuId - SKU ID
 * @param {number} param.buyAmount - 购买数量
 * @returns {Promise}
 */
export function modifyCartQuantity(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallShoppingCart/modify?isShop=1",
    {
      method: "POST",

      body: {
        param: {
          dealerItemSkuId: param.dealerItemSkuId,
          buyAmount: param.buyAmount,
        },
      },
    }
  );
}

// export function confirmOrder(param) {
//   return useNuxtApp().$customFetch(
//     "/mall/admin/mallOrder/confirmOrder?isShop=1",
//     {
//       method: "POST",
//       body: {
//         param: {
//           confirmOrderSkuReqDTOList: param.confirmOrderSkuReqDTOList,
//         },
//       },
//     }
//   );
// }
export function confirmOrder(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/confirmOrderWithOrderSplitAndGroup?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          confirmOrderSkuReqDTOList: param.confirmOrderSkuReqDTOList,
        },
      },
    }
  );
}

/**
 * 获取商品详情 - 用于购物车结算
 * @param {Object} param - 参数对象
 * @param {string} param.id - 商品ID
 * @param {string} param.spItemSpuId - SPU ID
 * @returns {Promise} API响应
 */
export function getItemSpuDetail(param) {

  if (!param.dealerShopId) {
    try {
      const dealerShopIdCookie = useCookie("dealerShopId", { path: "/" });
      if (dealerShopIdCookie && dealerShopIdCookie.value) {
        param.dealerShopId = dealerShopIdCookie.value;
      }
    } catch (e) {
      // SSR fallback: parse from incoming request headers
      if (headers && headers.cookie && typeof headers.cookie === "string") {
        const match = headers.cookie.match(/(?:^|;\s*)dealerShopId=([^;]+)/);
        if (match && match[1]) {
          try {
            param.dealerShopId = decodeURIComponent(match[1]);
          } catch (_) {}
        }
      }
    }
  }
  return useNuxtApp().$customFetch(
    "/mall/admin/mallGoods/itemSpuDetail?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          dealerShopId:param.dealerShopId,
          id: param.id,
          spItemSpuId: param.spItemSpuId
        }
      }
    }
  );
}

/**
 * 立即购买确认订单 - 直接购买接口
 * @param {Object} param - 参数对象
 * @param {Array} param.confirmOrderSkuReqDTOList - 订单商品列表
 * @returns {Promise} API响应
 */
export function buyNowConfirmOrder(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/confirmOrder?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          countryCode: param.countryCode || "CN",
          confirmOrderSkuReqDTOList: param.confirmOrderSkuReqDTOList
        }
      }
    }
  );
}

/**
 * 获取默认地址
 * @returns {Promise}
 */
export function getDefaultAddress() {
  return useNuxtApp().$customFetch(
    "/mall/admin/addressManage/getDefault?isShop=1",
    {
      method: "POST",
      body: {
        param: {},
      },
    }
  );
}

/**
 * 获取地址列表
 * @param {Object} param - 参数对象
 * @param {number} param.pageNo - 页码，从0开始
 * @param {number} param.pageSize - 每页大小
 * @returns {Promise}
 */
export function getAddressList(param = {}) {
  return useNuxtApp().$customFetch("/mall/admin/addressManage/list?isShop=1", {
    method: "POST",
    body: {
      param: {
        pageNo: param.pageNo || 0,
        pageSize: param.pageSize || 20,
      },
    },
  });
}

/**
 * 新增地址
 * @param {Object} param - 地址参数对象
 * @param {string} param.userRealname - 收货人姓名
 * @param {string} param.userMobile - 手机号码
 * @param {string} param.province - 省份
 * @param {string} param.city - 城市
 * @param {string} param.district - 区县
 * @param {string} param.detailAddress - 详细地址
 * @param {number} param.defaultState - 是否默认地址 (0:否, 1:是)
 * @param {number} param.sendType - 配送类型 (0:快递, 1:自提)
 * @param {string} param.siteAddress - 站点地址
 * @param {string} param.siteCode - 站点代码
 * @param {string} param.siteName - 站点名称
 * @param {string} param.siteType - 站点类型
 * @param {string} param.siteTypeName - 站点类型名称
 * @returns {Promise}
 */
export function addAddress(param) {
  return useNuxtApp().$customFetch("/mall/admin/addressManage/add?isShop=1", {
    method: "POST",
    body: {
      param: {
        userRealname: param.userRealname || "",
        userMobile: param.userMobile || "",
        province: param.province || "",
        city: param.city || "",
        district: param.district || "",
        detailAddress: param.detailAddress || "",
        defaultState: param.defaultState || 0,
        sendType: param.sendType || 0,
        siteAddress: param.siteAddress || "",
        siteCode: param.siteCode || "",
        siteName: param.siteName || "",
        siteType: param.siteType || "1",
        siteTypeName: param.siteTypeName || "",
      },
    },
  });
}

/**
 * 修改地址
 * @param {Object} param - 地址参数对象
 * @param {string} param.addressId - 地址ID
 * @param {string} param.userRealname - 收货人姓名
 * @param {string} param.userMobile - 手机号码
 * @param {string} param.province - 省份
 * @param {string} param.city - 城市
 * @param {string} param.district - 区县
 * @param {string} param.detailAddress - 详细地址
 * @param {number} param.defaultState - 是否默认地址 (0:否, 1:是)
 * @param {number} param.sendType - 配送类型 (0:快递, 1:自提)
 * @param {string} param.siteAddress - 站点地址
 * @param {string} param.siteCode - 站点代码
 * @param {string} param.siteName - 站点名称
 * @param {string} param.siteType - 站点类型
 * @param {string} param.siteTypeName - 站点类型名称
 * @returns {Promise}
 */
export function modifyAddress(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/addressManage/modify?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          addressId: param.addressId || "",
          userRealname: param.userRealname || "",
          userMobile: param.userMobile || "",
          province: param.province || "",
          city: param.city || "",
          district: param.district || "",
          detailAddress: param.detailAddress || "",
          defaultState: param.defaultState || 0,
          sendType: param.sendType || 0,
          siteAddress: param.siteAddress || "",
          siteCode: param.siteCode || "",
          siteName: param.siteName || "",
          siteType: param.siteType || "1",
          siteTypeName: param.siteTypeName || "",
        },
      },
    }
  );
}

/**
 * 删除地址
 * @param {Object} param - 地址参数对象
 * @param {string} param.addressId - 地址ID
 * @returns {Promise}
 */
export function deleteAddress(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/addressManage/delete?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          addressId: param.addressId || "",
        },
      },
    }
  );
}

/**
 * 创建订单
 * @param {Object} param - 订单参数对象
 * @param {Array} param.createOrderSkuReqDTOList - 订单商品列表
 * @param {string} param.addressId - 地址ID
 * @param {Array} param.giftCardActivityDetailIdList - 礼品卡活动详情ID列表
 * @param {string} param.mobileNo - 手机号码（当联系方式为手机号时）
 * @param {string} param.email - 邮箱地址（当联系方式为邮箱时）
 * @param {string} param.dealerShopId - 店铺ID（未登录用户需要）
 * @param {string} param.lineId - Line ID
 * @param {string} param.userIP - 用户 IP 地址
 * @param {string} param.ipCountry - IP 解析后的国家信息
 * @param {Object} param.ipLocation - IP 详细位置信息（包含国家、城市、经纬度、ISP等）
 * @param {string} param.domainName - 域名信息
 * @param {string} param.platformSource - 平台来源
 * @returns {Promise}
 */
export function createOrder(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/createOrder?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          createOrderSkuReqDTOList: param.createOrderSkuReqDTOList || [],
          addressId: param.addressId || "",
          giftCardActivityDetailIdList:
            param.giftCardActivityDetailIdList || [],
          mobileNo: param.mobileNo || "",
          email: param.email || "",
          dealerShopId: param.dealerShopId || "",
          lineId: param.lineId || "",
          customerAddressDTO: param.customerAddressDTO || {},
          userIP: param.userIP || "",
          ipCountry: param.ipCountry || "",
          ipLocation: param.ipLocation || null,
          domainName: param.domainName || "",
          platformSource: param.platformSource || "",
        },
      },
    }
  );
}

/**
 * 查询小程序支付订单
 * @param {Object} param - 查询参数对象
 * @param {string} param.payOrderCode - 支付订单编码
 * @param {number} param.payType - 支付类型
 * @returns {Promise}
 */
export function queryMiniProgramPayOrderByBizTradeId(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/queryMiniProgramPayOrderByBizTradeId?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          payOrderCode: param.payOrderCode || "",
          payType: param.payType || 2,
        },
      },
    }
  );
}

/**
 * 获取地址树数据（省份、城市、区县）
 * @param {Object} param - 查询参数对象
 * @param {number} param.param - 地址级别参数，4表示获取完整地址树
 * @returns {Promise}
 */
export function getAddressTree(param = {}) {
  return useNuxtApp().$customFetch(
    "/mall/portal/addressLibrary/getAddressTree?isShop=1",
    {
      method: "POST",
      body: {
        param: param.param || 4,
      },
      headers: {
        Accept: "*/*",
        "Accept-Language": "zh-CN,zh;q=0.9",
        "Content-Type": "application/json;charset=UTF-8",
        Origin: "http://mallfront.mps.omszt.com:7001",
        "Proxy-Connection": "keep-alive",
        Referer: "http://mallfront.mps.omszt.com:7001/",
        "User-Agent":
          "Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/125.0.0.0 Mobile Safari/537.36",
      },
    }
  );
}

/**
 * 获取7-11自提点地址列表
 * @param {Object} param - 查询参数对象
 * @param {string} param.country - 国家/地区
 * @param {string} param.pickupPointMode - 自提点模式 (1: 7-11)
 * @param {string} param.province - 省份
 * @param {string} param.city - 城市
 * @param {string} param.district - 区县
 * @param {string} param.detailAddress - 详细地址
 * @param {string} param.dealerShopId - 店铺ID
 * @param {number} param.pageNo - 页码，从0开始
 * @param {number} param.pageSize - 每页大小
 * @returns {Promise}
 */
export function get711AddressList(param = {}) {
 
  return useNuxtApp().$customFetch(
    "/mall/admin/addressManage/dealer-shop-zt-address/pageList?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          country: param.country || "中國臺灣",
          dealerShopId:    (process.client ?useCookie('dealerShopId').value : ""),
          pickupPointMode: param.pickupPointMode || "1",
          province: param.province || "",
          // dealerShopId: param.dealerShopId || "",
          district: param.district || "",
          city: param.city || "",
          detailAddress: param.detailAddress || "",
          street: param.street || "",
          pageNo: param.pageNo || 0,
          pageSize: param.pageSize || 1000,
        },
      },

      // {
      //   method: "POST",
      //   body: {
      //     param: {
      //       country: param.country || "中國臺灣",
      //       pickupPointMode: param.pickupPointMode || "1",
      //       province: param.province || "",
      //       dealerShopId: param.dealerShopId || "",
      //       district: param.district || "",
      //       city: param.city || "",
      //       detailAddress: param.detailAddress || "",
      //       pageNo: param.pageNo || 0,
      //       pageSize: param.pageSize || 20
      //     }
      //   },
      // headers: {
      //   'Accept': '*/*',
      //   'Accept-Language': 'zh-CN,zh-TW;q=0.9,zh;q=0.8,ja;q=0.7',
      //   'Cache-Control': 'no-cache',
      //   'Connection': 'keep-alive',
      //   'Content-Type': 'application/json;charset=UTF-8',
      //   'Origin': 'https://runpiggy.com',
      //   'Pragma': 'no-cache',
      //   'Referer': 'https://runpiggy.com/h5/pages/userPages/address/CourierPickupPointList',
      //   'Sec-Fetch-Dest': 'empty',
      //   'Sec-Fetch-Mode': 'cors',
      //   'Sec-Fetch-Site': 'same-origin',
      //   'User-Agent': 'Mozilla/5.0 (iPhone; CPU iPhone OS 18_5 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/18.5 Mobile/15E148 Safari/604.1'
      // }
    }
  );
}

export function queryMallOrderList(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/queryMallOrderList?isShop=1",
    {
      method: "POST",
      body: {
        param,
      },
    }
  );
}
/**
 * 获取商品评论列表
 * @param {Object} param - 查询参数对象
 * @param {string} param.dealerItemSpuId - 商品SPU ID
 * @param {number} param.commentType - 评论类型 (1:商品评论)
 * @param {Array} param.commentStateList - 评论状态列表 [1,2] (1:已审核, 2:待审核)
 * @param {number} param.haveImg - 是否有图片 (0:全部, 1:有图片)
 * @param {number} param.haveVideo - 是否有视频 (0:全部, 1:有视频)
 * @param {number} param.addCommentState - 是否有追评 (0:全部, 1:有追评, 2:无追评)
 * @param {number} param.pageNo - 页码，从0开始
 * @param {number} param.pageSize - 每页大小
 * @returns {Promise}
 */
export function getItemCommentBySpuId(param = {}) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallItemComment/getItemCommentBySpuId?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          dealerShopId: param.dealerShopId || "",
          dealerItemSpuId: param.dealerItemSpuId || "",
          commentType: param.commentType || 1,
          commentStateList: param.commentStateList || [1, 2],
          haveImg: param.haveImg !== undefined ? param.haveImg : undefined,
          haveVideo: param.haveVideo !== undefined ? param.haveVideo : undefined,
          addCommentState: param.addCommentState !== undefined ? param.addCommentState : undefined,
          pageNo: param.pageNo || 0,
          pageSize: param.pageSize || 20
        }
      },
      headers: {
        'Accept': '*/*',
        'Accept-Language': 'zh-CN,zh;q=0.9',
        'Connection': 'keep-alive',
        'Content-Type': 'application/json;charset=UTF-8',
        'Origin': 'http://mallfront.mps.omszt.com:7001',
        'Referer': 'http://mallfront.mps.omszt.com:7001/',
        'User-Agent': 'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/125.0.0.0 Mobile Safari/537.36'
      }
    }
  );
}

/**
 * 查询商品评论分页列表
 * 对应接口：/mall/admin/dealerItemSpuReview/queryDealerItemSpuReviewPage
 * @param {Object} param
 * @param {string|number} param.dealerShopId - 店铺ID
 * @param {string|number} param.dealerItemSpuId - 商品SPU ID
 * @param {number} [param.pageNo=0] - 页码
 * @param {number} param.pageSize - 每页大小
 * @returns {Promise}
 */
export function getProductReviewPage(param = {}) {
  return useNuxtApp().$customFetch(
    "/mall/admin/dealerItemSpuReview/queryDealerItemSpuReviewPage",
    {
      method: "POST",
      body: {
        param: {
          dealerShopId: param.dealerShopId || "",
          dealerItemSpuId: param.dealerItemSpuId || "",
          pageNo: param.pageNo != null ? param.pageNo : 0,
          pageSize: param.pageSize || 20,
        },
      },
    }
  );
}

/**
 * 获取店铺评论列表
 * 对应接口：/mall/admin/dealerItemSpuReview/queryShopReviewPage
 * @param {Object} param
 * @param {string|number} param.dealerShopId - 店铺ID
 * @param {number} [param.pageNo=0] - 页码
 * @param {number} param.pageSize - 每页大小
 * @returns {Promise}
 */
export function getShopReviewPage(param = {}) {
  return useNuxtApp().$customFetch(
    "/mall/admin/dealerItemSpuReview/queryShopReviewPage",
    {
      method: "POST",
      body: {
        param: {
          dealerShopId: param.dealerShopId || "",
          pageNo: param.pageNo != null ? param.pageNo : 0,
          pageSize: param.pageSize || 20,
        },
      },
    }
  );
}

/**
 * 添加评论（商品评论和店铺评论公用）
 * 对应接口：/mall/admin/dealerItemSpuReview/addDealerItemSpuReview
 * @param {Object} param
 * @param {number} param.type - 评论类型 0=商品评论, 1=店铺评论
 * @param {string|number} [param.dealerItemSpuId] - 商品SPU ID（商品评论必填）
 * @param {string|number} [param.dealerShopId] - 店铺ID
 * @param {string|number} [param.shopId] - 店铺ID (deprecated)
 * @param {string|number} [param.spInfoId] - SP信息ID
 * @param {string|number} [param.dealerInfoId] - 经销商ID
 * @param {number} param.score - 评分 1-5
 * @param {string} param.commentContent - 评论内容
 * @param {string} [param.reviewContent] - 回复内容
 * @param {Array<string>} [param.commentImgUrlList] - 图片URL列表
 * @param {Array<string>} [param.commentVideoUrlList] - 视频URL列表
 * @param {string} param.name - 用户名
 * @param {string} param.email - 用户邮箱
 * @returns {Promise}
 */
export function addReview(param = {}) {
  console.log('addReview API called with params:', {
    type: param.type,
    dealerItemSpuId: param.dealerItemSpuId,
    dealerShopId: param.dealerShopId,
    shopId: param.shopId,
    spInfoId: param.spInfoId,
    dealerInfoId: param.dealerInfoId,
  })
  
  return useNuxtApp().$customFetch(
    "/mall/admin/dealerItemSpuReview/addDealerItemSpuReview",
    {
      method: "POST",
      body: {
        param: {
          type: param.type,
          dealerItemSpuId: param.dealerItemSpuId,
          dealerShopId: param.dealerShopId,
          shopId: param.shopId,
          spInfoId: param.spInfoId,
          dealerInfoId: param.dealerInfoId,
          score: param.score || 5,
          commentContent: param.commentContent || "",
          reviewContent: param.reviewContent || "",
          commentImgUrlList: param.commentImgUrlList || [],
          commentVideoUrlList: param.commentVideoUrlList || [],
          name: param.name || "",
          email: param.email || "",
        },
      },
    }
  );
}


/**
 * 根据订单编码查询评论列表
 * 对应接口：/mall/admin/mallItemComment/getItemCommentList
 * @param {Object} param
 * @param {string} param.orderCode - 订单编码
 * @param {number} [param.commentType=1] - 评论类型
 * @param {number} [param.commentState=1] - 评论状态
 * @param {string|number} [param.dealerShopId] - 店铺ID（可从 cookie 读取）
 */
export function getItemCommentList(param = {}) {
  const bodyParam = {
    orderCode: param.orderCode || "",
    commentType: param.commentType != null ? param.commentType : 1,
    commentState: param.commentState != null ? param.commentState : 1,
    dealerShopId: param.dealerShopId,
  };

  // 若未显式传入 dealerShopId，尝试从 cookie 读取（仅客户端）
  if (!bodyParam.dealerShopId) {
    try {
      const dealerShopIdCookie = process.client ? useCookie("dealerShopId", { path: "/" }) : null;
      if (dealerShopIdCookie && dealerShopIdCookie.value) {
        bodyParam.dealerShopId = dealerShopIdCookie.value;
      }
    } catch (_) {}
  }

  return useNuxtApp().$customFetch(
    "/mall/admin/mallItemComment/getItemCommentList?isShop=1",
    {
      method: "POST",
      body: { param: bodyParam },
      headers: {
        Accept: "application/json",
        "Accept-Language": "zh-CN,zh;q=0.9,en;q=0.8",
        "Content-Type": "application/json;charset=UTF-8",
      },
    }
  );
}

/**
 * 获取订单详情
 * @param {Object} param - 参数对象
 * @param {string} param.id - 订单ID
 * @param {string} param.orderCode - 订单编码
 * @returns {Promise}
 */
export function queryMallOrderDetail(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/queryMallOrderDetail?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          id: param.id || "",
          orderCode: param.orderCode || "",
        },
      },
    }
  );
}

// /**
//  * 查询订单详情 - 用于订单详情页面
//  * @param {Object} param - 参数对象
//  * @param {string} param.id - 订单ID
//  * @param {string} param.orderCode - 订单编码
//  * @returns {Promise}
//  */
// export function querySelectionAppDealerOrderDetail(param) {
//   console.log(param,"param")
//   return useNuxtApp().$customFetch(
//     "/mall/admin/mallOrder/querySelectionAppDealerOrderDetail?isShop=1",
//     {
//       method: "POST",
//       body: {
//         param: {
//           id: '1192486561249447936'         },
//       },
//     }
//   );
// }

export function querySelectionAppDealerOrderDetail(params, $fetch, headers) {  
  const body = {
    param: {
      orderCode: params?.orderCode || params?.param?.orderCode || ""
    }
  };
  
  console.log(body, "body");

  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/mall/admin/mallOrder/querySelectionAppDealerOrderDetail?isShop=1",
      {
        method: "POST",
        body,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/mall/admin/mallOrder/querySelectionAppDealerOrderDetail?isShop=1",
      {
        method: "POST",
        body,
      }
    );
  }
}

/**
 * 取消订单
 * @param {Object} param - 参数对象
 * @param {string} param.dealerOrderPrimaryId - 订单ID
 * @returns {Promise}
 */
export function cancelOrder(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/cancelOrder?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          dealerOrderPrimaryId: param.dealerOrderPrimaryId,
        },
      },
    }
  );
}

/**
 * 申请退款
 * @param {Object} param - 参数对象
 * @param {string} param.dealerOrderPrimaryId - 订单ID
 * @returns {Promise}
 */
export function refundOrder(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/orderRefund/createOrderRefund?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          dealerOrderPrimaryId: param.dealerOrderPrimaryId,
        },
      },
    }
  );
}

/**
 * 确认收货
 * @param {Object} param - 参数对象
 * @param {string} param.dealerOrderPrimaryId - 订单ID
 * @returns {Promise}
 */
export function confirmReceive(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/confirmReceive?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          dealerOrderPrimaryId: param.dealerOrderPrimaryId,
        },
      },
    }
  );
}

/**
 * 支付订单
 * @param {Object} param - 参数对象
 * @param {Array} param.mallOrderDTOList - 订单列表
 * @param {string} param.orderId - 订单ID
 * @param {string} param.version - 版本号
 * @returns {Promise}
 */
export function payOrder(param) {
  return useNuxtApp().$customFetch("/mall/admin/mallOrder/payOrder?isShop=1", {
    method: "POST",
    body: {
      param: {
        mallOrderDTOList: param.mallOrderDTOList || [],
        orderId: param.orderId || "",
        version: param.version || "",
      },
    },
  });
}

//查看我的各种状态订单个数
export function querySelectionAppDealerOrderSummary(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/queryMallOrderSummary?isShop=1",
    {
      method: "POST",
      body: param,
    }
  );
}

export function addSpItem2Dealer(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/addSpItem2Dealer?isShop=1",
    {
      method: "POST",
      body: param,
    }
  );
}
  
// 合并支付
export function paymentOrder(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/paymentOrder?isShop=1",
    {
      method: "POST",
      body: param,
    }
  );
}

// 单个支付
export function paymentSingleOrder(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/paymentSingleOrder?isShop=1",
    {
      method: "POST",
      body: param,
    }
  );
}

// 单个支付
export function unpaymentOrder(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/unpaymentOrder?isShop=1",
    {
      method: "POST",
      body: param,
    }
  );
}

// 单个支付
export function unpaymentSingleOrder(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/unpaymentSingleOrder?isShop=1",
    {
      method: "POST",
      body: param,
    }
  );
}

// 合并支付
export function getStoreConfig(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/getStoreConfig?isShop=1",
    {
      method: "POST",
      body: param,
    }
  );
}

/**
 * 校验折扣碼
 * @param {Object} param - 参数对象
 * @param {Array} param.confirmOrderSkuReqDTOList - 订单商品列表（每个成员需包含 discountCode 和 dealerShopId）
 * @returns {Promise}
 */
export function validateDiscountCode(param) {
  return useNuxtApp().$customFetch(
    "/mall/admin/discount/validateDiscountCode?isShop=1",
    {
      method: "POST",
      body: {
        param: {
          confirmOrderSkuReqDTOList: param.confirmOrderSkuReqDTOList
        }
      }
    }
  );
}

 
 
 
/**
 * 新增商品评论
 * 使用接口：/admin/mallItemComment/addItemAddComment
 * 为保持与现有接口风格一致，前缀沿用 /mall/admin，并追加 isShop=1
 * @param {Object} param - 评论参数对象，原样透传至后端
 * @returns {Promise}
 */
export function addItemAddComment(param = {}) {
  return useNuxtApp().$customFetch(
    "/mall/admin/mallItemComment/addItemCommentList?isShop=1",
    {
      method: "POST",
      body: {
        param: [{
          ...param
        }]
      }
    }
  );
}

/**
 * 根据订单查询评论并返回首条评论ID
 * 对应后端：/api/cmsadmin/mall/admin/mallItemComment/getItemCommentList?isShop=1
 * @param {Object} param
 * @param {string} param.orderCode - 订单编码
 * @param {number} [param.commentType=1]
 * @param {number} [param.commentState=1]
 * @param {string|number} [param.dealerShopId]
 * @returns {Promise<string|undefined>} 首条评论ID
 */
export function getItemCommentFirstId(param = {}) {
  const bodyParam = {
    orderCode: param.orderCode || "",
    commentType: param.commentType != null ? param.commentType : 1,
    commentState: param.commentState != null ? param.commentState : 1,
    dealerShopId: param.dealerShopId,
  };

  if (!bodyParam.dealerShopId) {
    try {
      const dealerShopIdCookie = process.client ? useCookie("dealerShopId", { path: "/" }) : null;
      if (dealerShopIdCookie && dealerShopIdCookie.value) {
        bodyParam.dealerShopId = dealerShopIdCookie.value;
      }
    } catch (_) {}
  }

  return useNuxtApp()
    .$customFetch(
      "/mall/admin/mallItemComment/getItemCommentList?isShop=1",
      {
        method: "POST",
        body: { param: bodyParam },
        headers: {
          Accept: "application/json",
          "Accept-Language": "zh-CN,zh;q=0.9,en;q=0.8",
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    )
    .then((res) => {
      try {
        return res?.data?.dataList?.[0]?.id;
      } catch (_) {
        return undefined;
      }
    });
}

/**
 * 获取阿里云 OSS 上传 token
 * @returns {Promise}
 */
export function getAliyunToken() {
  
  return useNuxtApp().$customFetch(
    "/mall/basic/aliyun/getToken?isShop=1",
    {
      method: "GET"
    }
  );
}

/**
 * 查询订单列表（不需要登录）- C端订单查询
 * @param {Object} param - 查询参数对象
 * @param {string} param.mobileNo - 用户手机号
 * @param {string} param.email - 用户邮箱
 * @param {string} param.nickname - 用户昵称/名字
 * @param {string} param.account - 用户账号
 * @param {string} param.lineId - LineId
 * @param {string} param.orderCode - 订单号
 * @param {string} param.dealerShopId - 店铺ID
 * @returns {Promise}
 */
export function queryMallOrderListNoLogin(param = {}) {
  const bodyParam = {
    param: {
      mobileNo: param.mobileNo !== undefined ? param.mobileNo : null,
      email: param.email !== undefined ? param.email : null,
      nickname: param.nickname !== undefined ? param.nickname : null,
      account: param.account !== undefined ? param.account : null,
      lineId: param.lineId !== undefined ? param.lineId : null,
      orderCode: param.orderCode !== undefined ? param.orderCode : null
    }
  }

  // 获取 dealerShopId
  if (!bodyParam.dealerShopId) {
    if (param.dealerShopId) {
      bodyParam.param.dealerShopId = param.dealerShopId
    } else {
      try {
        const dealerShopIdCookie = process.client ? useCookie("dealerShopId", { path: "/" }) : null
        if (dealerShopIdCookie && dealerShopIdCookie.value) {
          bodyParam.param.dealerShopId = dealerShopIdCookie.value
        }
      } catch (e) {
        // no-op
      }
    }
  }

  return useNuxtApp().$customFetch(
    "/mall/admin/mallOrder/queryMallOrderListWithSpAndOrderCodeGroupNoLogin",
    {
      method: "POST",
      body: bodyParam
    }
  );
}

